import React from "react";
import { Outlet } from "react-router-dom";

const MainLayout: React.FC<any> = () => {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
};

export default MainLayout;
